export enum DependsOnTables {
    None= 0,
    Client= 1,
    Matter= 2,
    Timekeeper= 3,
    ClientMatter= 4
}